var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrike2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.2989 14V12.558H9.15491C11.6609 10.668 13.2429 9.128 13.2429 7.406C13.2429 5.544 11.6609 4.522 9.85491 4.522C8.55291 4.522 7.23691 5.026 6.41091 6.02L7.36291 7.098C7.95091 6.426 8.79091 5.978 9.88291 5.978C10.7369 5.978 11.5769 6.426 11.5769 7.406C11.5769 8.75 10.1629 9.968 6.53691 12.712V14H13.2989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike2);
export default __webpack_public_path__ + "static/media/strike_2.10d961dde18932a55d5090b82e71a6c8.svg";
export { ForwardRef as ReactComponent };